/**
 * Promo popup (newsletter signup). Vanilla JS rewrite of the original
 * jQuery-based script from the source template -- jQuery was never loaded
 * in this theme, so the old script crashed on every page load and the
 * popup never actually opened. This implements exactly the behavior the
 * section schema exposes: open trigger ("scroll" or "time"), a per-visitor
 * display limit that resets after N days, and open/close fade animations
 * using the existing .popup-animated / popupOpenFade / popupExitFade CSS
 * already shipped in base.css.
 *
 * Expected markup (see sections/popup.liquid):
 *   <div class="popup-main popup ..." data-id="..." data-open-trigger="scroll|time" ...></div>
 *   <div class="popup-overlay"></div>
 */
(function () {
  function getStorage(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return undefined;
      var parsed = JSON.parse(raw);
      if (parsed.expires && Date.now() > parsed.expires) {
        localStorage.removeItem(key);
        return undefined;
      }
      return parsed.value;
    } catch (e) {
      return undefined;
    }
  }

  function setStorage(key, value, days) {
    var data = { value: value, expires: null };
    var parsedDays = parseInt(days, 10);
    if (parsedDays) {
      var expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + parsedDays);
      data.expires = expiryDate.getTime();
    }
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) -- popup will just
         re-open every visit instead of respecting the display limit. */
    }
  }

  function getScrollPercent() {
    var doc = document.documentElement;
    var body = document.body;
    var scrollTop = doc.scrollTop || body.scrollTop;
    var scrollHeight = (doc.scrollHeight || body.scrollHeight) - doc.clientHeight;
    if (scrollHeight <= 0) return 100;
    return (scrollTop / scrollHeight) * 100;
  }

  function animateEl(el, animationName, callback) {
    if (!el) {
      if (callback) callback();
      return;
    }
    el.classList.add('popup-animated', animationName);
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      el.classList.remove('popup-animated', animationName);
      el.removeEventListener('animationend', finish);
      if (callback) callback();
    };
    el.addEventListener('animationend', finish);
    /* Safety net in case the animationend event never fires (animation
       already complete, reduced-motion, etc.) -- matches the CSS's
       .popup-animated 0.5s animation-duration. */
    setTimeout(finish, 600);
  }

  function initPopup(popup) {
    if (popup.dataset.popupBound === 'true') return;
    popup.dataset.popupBound = 'true';

    var overlay = popup.nextElementSibling;
    if (!overlay || !overlay.classList.contains('popup-overlay')) overlay = null;
    var wrap = popup.querySelector('.popup-wrap');

    var id = popup.dataset.id || '';
    var storageKey = 'popup-' + id;
    var limitDisplay = parseInt(popup.dataset.limitDisplay || '0', 10);
    var limitLifetimeDays = popup.dataset.limitLifetime;
    var trigger = popup.dataset.openTrigger;

    function isAllowed() {
      if (!limitDisplay) return true;
      var count = parseInt(getStorage(storageKey) || 0, 10);
      return count < limitDisplay;
    }

    function markShown() {
      var count = parseInt(getStorage(storageKey) || 0, 10) + 1;
      setStorage(storageKey, count, limitLifetimeDays);
    }

    function openPopup() {
      if (popup.classList.contains('popup-open')) return;
      if (!isAllowed()) return;
      markShown();
      popup.classList.add('popup-open');
      document.body.classList.add('popup-scroll-hidden');
      animateEl(wrap, 'popupOpenFade');
      animateEl(overlay, 'popupOpenFade');
    }

    function closePopup() {
      if (!popup.classList.contains('popup-open')) return;
      animateEl(wrap, 'popupExitFade', function () {
        popup.classList.remove('popup-open');
        document.body.classList.remove('popup-scroll-hidden');
      });
      animateEl(overlay, 'popupExitFade');
    }

    popup.querySelectorAll('.popup-close').forEach(function (btn) {
      btn.addEventListener('click', closePopup);
    });

    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') closePopup();
    });

    if (!isAllowed()) return;

    if (trigger === 'time') {
      var seconds = parseFloat(popup.dataset.openDelayNumber || '0');
      setTimeout(openPopup, Math.max(seconds, 0) * 1000);
    } else if (trigger === 'scroll') {
      var targetPercent = parseFloat(popup.dataset.openScrollPosition || '0');
      var onScroll = function () {
        if (getScrollPercent() >= targetPercent) {
          openPopup();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function initAllPopups() {
    document.querySelectorAll('.popup').forEach(initPopup);
  }

  document.addEventListener('DOMContentLoaded', initAllPopups);
  document.addEventListener('shopify:section:load', initAllPopups);
  document.addEventListener('shopify:section:unload', function () {
    document.body.classList.remove('popup-scroll-hidden');
  });
})();
